import * as Common from '../Common/modules'
import * as Models from '../Models'

    export interface IAdminApiClient {
        getUserProfiles: (getUserProfilesrequest: Models.Admin.GetUserProfilesRequest.IGetUsersRequest) => ng.IPromise<Models.Admin.GetUserProfilesResponse.IGetUserProfilesResponse>;
        getRoles: () => ng.IPromise<Array<string>>;
        createUser: (createUserRequest:  Models.Admin.CreateUserRequest.ICreateUserRequest) => ng.IPromise<Models.Admin.CreateUserResponse.CreateUserResponse>;
        editRoles: (editRolesRequest: Models.Admin.EditRolesRequest.IEditRolesRequest) => ng.IPromise<Models.Admin.EditRolesResponse.EditRolesResponse>;
        unlockUser: (unlockUserRequest: Models.Admin.UnlockUserRequest.IUnlockUserRequest) => ng.IPromise<Models.Admin.UnlockUserResponse.IUnlockUserResponse>;
        editApproved: (editApprovedRequest: Models.Admin.EditApprovedRequest.IEditApprovedRequest) => ng.IPromise<Models.Admin.EditApprovedResponse.IEditApprovedResponse>;
        changeUserName: (changeUserNameRequest: Models.Admin.ChangeUsernameRequest.IChangeUsernameRequest) => ng.IPromise<Models.Admin.ChangeUsernameResponse.IChangeUsernameResponse>;
        userNameAvailable: (userNameAvailableRequest: Models.Admin.UsernameAvailableRequest.IUsernameAvailableRequest) => ng.IPromise<Models.Admin.UsernameAvailableResponse.IUsernameAvailableResponse>;
        changePassword: (changePasswordRequest: Models.Admin.ChangePasswordRequest.IChangePasswordRequest) => ng.IPromise<Models.Admin.ChangePasswordResponse.IChangePasswordResponse>;
    }

    export class AdminApiClient implements IAdminApiClient {
        
        private baseUrl = 'api/admin/';

        public static $inject = ['ApiClient'];
        constructor(private apiClient: Common.ApiClientService.Igs.Common.IApiClientService) {}

        public getUserProfiles = (getUserProfilesrequest:  Models.Admin.GetUserProfilesRequest.IGetUsersRequest): ng.IPromise<Models.Admin.GetUserProfilesResponse.IGetUserProfilesResponse> => {
            return this.apiClient.post(this.baseUrl + 'getuserprofiles', getUserProfilesrequest);
        };

        public getRoles = (): ng.IPromise<Array<string>> => {
            return this.apiClient.get(this.baseUrl + 'roles');
        };

        public createUser = (createUserRequest: Models.Admin.CreateUserRequest.ICreateUserRequest): ng.IPromise<Models.Admin.CreateUserResponse.CreateUserResponse> => {
            return this.apiClient.post(this.baseUrl + 'createuser', createUserRequest);
        };

        public editRoles = (editRolesRequest: Models.Admin.EditRolesRequest.IEditRolesRequest): ng.IPromise<Models.Admin.EditRolesResponse.EditRolesResponse> => {
            return this.apiClient.post(this.baseUrl + 'editroles', editRolesRequest);
        };

        public unlockUser = (unlockUserRequest: Models.Admin.UnlockUserRequest.IUnlockUserRequest): ng.IPromise<Models.Admin.UnlockUserResponse.IUnlockUserResponse> => {
            return this.apiClient.post(this.baseUrl + 'unlockuser', unlockUserRequest);
        };

        public editApproved = (editApprovedRequest: Models.Admin.EditApprovedRequest.IEditApprovedRequest): ng.IPromise<Models.Admin.EditApprovedResponse.IEditApprovedResponse> => {
            return this.apiClient.post(this.baseUrl + 'editapproved', editApprovedRequest);
        };

        public changeUserName = (changeUserNameRequest: Models.Admin.ChangeUsernameRequest.IChangeUsernameRequest): ng.IPromise<Models.Admin.ChangeUsernameResponse.IChangeUsernameResponse> => {
            return this.apiClient.post(this.baseUrl + 'changeusername', changeUserNameRequest);
        };

        public userNameAvailable = (userNameAvailableRequest: Models.Admin.UsernameAvailableRequest.IUsernameAvailableRequest): ng.IPromise<Models.Admin.UsernameAvailableResponse.IUsernameAvailableResponse> => {
            return this.apiClient.post(this.baseUrl + 'usernameavailable', userNameAvailableRequest);
        };

        public changePassword = (changePasswordRequest: Models.Admin.ChangePasswordRequest.IChangePasswordRequest): ng.IPromise<Models.Admin.ChangePasswordResponse.IChangePasswordResponse> => {
            return this.apiClient.post(this.baseUrl + 'changepassword', changePasswordRequest);
        };
    }
